import React from 'react';
import cn from 'classnames';
import type { NodeToRenderProps, NodeToRenderData } from '@src/components/custom-nodes/types';
import { ExclamationTriangleIcon } from '@radix-ui/react-icons';
import { CustomTooltip } from '@src/components/tooltip/Tooltip';
import { useAtom } from 'jotai';
import { nodeValidationResultAtom } from '@src/atoms';

// LF360-1823 (#118): text-red-500 - сирий Tailwind-колір; --destructive у темі має те саме
// значення в світлій темі (hsl(0 84.2% 60.2%) === #EF4444), тож візуально це no-op, але
// іконка починає адаптуватися до темної теми. size-4 - ті самі 16px, що й решта іконок.
export const withNodeValidation = (WrappedComponent: React.FC<NodeToRenderProps>) => {
  return function WithNodeValidationWrapper(props: NodeToRenderProps) {
    const propsData = props.data as NodeToRenderData;
    const shouldAdjustIconPosition = ['if:condition', 'if:condition-behavior', 'timer:wait'].includes(propsData?.nodeType ?? '');
    const [nodeValidationResult] = useAtom(nodeValidationResultAtom);

    const validationItem = nodeValidationResult.find((item) => item?.id === props?.id);

    return (
      <div className="relative">
        {validationItem?.success === false && (
          <div className={cn(["absolute top-2 right-2", { 'right-12': shouldAdjustIconPosition }])}>
            <CustomTooltip content="Validation errors are found">
              <ExclamationTriangleIcon className="size-4 text-destructive" />
            </CustomTooltip>
          </div>
        )}
        <WrappedComponent
          {...props}
          >
            {props.children}
        </WrappedComponent>
      </div>
    );
  };
}
